import React, { useState } from "react";
import { FoCard, FoChips, statusBadge } from "./financeUi";
import { os } from "./osClient";
import { PagerTable, TextField, useOsResource } from "./osForm";
import { AUDIT_KINDS, describeValue, formatStamp, pageMeta } from "./osRules";

export default function AuditLog() {
  const [kind, setKind] = useState("");
  const [search, setSearch] = useState("");
  const [applied, setApplied] = useState({ kind: "", search: "" });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const list = useOsResource(
    (auth) => os.audit(auth, { kind: applied.kind, search: applied.search, page, limit }),
    [applied.kind, applied.search, page, limit]
  );
  const pack = pageMeta(list.data?.entries || list.data);

  return (
    <div className="fo-stack">
      <div className="fo-tools">
        <FoChips
          options={[{ value: "", label: "All" }, ...AUDIT_KINDS.map((value) => ({ value, label: value }))]}
          value={kind}
          onChange={setKind}
        />
        <TextField label="Search" value={search} onChange={setSearch} hint="Actor, note, or entity type" />
        <button type="button" className="fo-btn" onClick={() => { setPage(1); setApplied({ kind, search: search.trim() }); }}>Apply</button>
      </div>
      <FoCard title="Audit log" note="Append-only. Entries cannot be edited or deleted.">
        <PagerTable
          loading={list.loading}
          dataSource={pack.docs}
          rowKey={(row) => row._id || `${row.createdAt}-${row.note}`}
          page={page}
          limit={limit}
          total={pack.total}
          minWidth={980}
          onChange={(nextPage, nextLimit) => { setPage(nextPage); setLimit(nextLimit); }}
          empty="No audit entries match."
          columns={[
            { title: "When", dataIndex: "createdAt", render: (value) => formatStamp(value) },
            { title: "Actor", dataIndex: "actor" },
            { title: "Kind", dataIndex: "kind", render: (value) => statusBadge(value) },
            { title: "Entity", dataIndex: "entityType" },
            { title: "Previous", dataIndex: "previousValue", render: (value) => <span className="fo-note">{describeValue(value)}</span> },
            { title: "Next", dataIndex: "nextValue", render: (value) => <span className="fo-note">{describeValue(value)}</span> },
            { title: "Note", dataIndex: "note" },
          ]}
        />
      </FoCard>
    </div>
  );
}
